<template>
    <Modal :open="displayModal" @close="displayModal = false">
        <div class="w-full bg-white shadow-lg rounded-none md:rounded-lg p-6">

            <div class="w-full relative">
                <h2 class="font-semibold text-gray-900 text-2xl leading-tight border-b-2 border-gray-200 pb-4">Video Approval</h2>
                <button class="text-grey-darkest font-bold rounded absolute top-0 right-0 outline-none text-xl absolute" @click="displayModal = false">
                    <i class="fas fa-times"></i>
                </button>
            </div>

            <div class="mt-4">

                <YouTubePlayer :youtube_id="data.youtube_id" />

                <div class="md:flex md:items-center mb-6 mt-6">
                    <div class="md:w-1/3">
                        <label class="block text-grey-darkest font-bold md:text-left mb-1 md:mb-0 pr-4" for="inline-full-name">
                            Price
                        </label>
                    </div>
                    <div class="md:w-2/3">
                        <input class="bg-grey-lighter appearance-none border-2 border-grey-lighter rounded w-full py-2 px-4 text-grey-darker leading-tight focus:outline-none focus:bg-white focus:border-grey-darkest" id="inline-full-name" type="number" v-model="price">
                    </div>
                </div>

                <div class="md:flex md:items-center mb-6 mt-6">
                    <div class="md:w-1/3">
                        <label class="block text-grey-darkest font-bold md:text-left mb-1 md:mb-0 pr-4" for="inline-full-name">
                            Rating
                        </label>
                    </div>
                    <div class="md:w-2/3 flex">
                        <div class="w-1/2">
                            <input class="bg-grey-lighter appearance-none border-2 border-grey-lighter rounded w-full py-2 px-4 text-grey-darker leading-tight focus:outline-none focus:bg-white focus:border-grey-darkest" id="inline-full-name" type="text" v-model="rating" placeholder="3.5">
                        </div>
                        <div class="w-1/2 flex justify-center items-center">
                            <StarRating id="starRating" :rating="(rating > 5) ? 0 : rating" />
                        </div>
                    </div>
                </div>

                <div class="md:flex md:items-center mb-6">
                    <div class="md:w-1/3">
                        <label class="block text-grey-darkest font-bold md:text-left mb-1 md:mb-0 pr-4" for="inline-full-name">
                            Video Title
                        </label>
                    </div>
                    <div class="md:w-2/3">
                        <input class="bg-grey-lighter appearance-none border-2 border-grey-lighter rounded w-full py-2 px-4 text-grey-darker leading-tight focus:outline-none focus:bg-white focus:border-grey-darkest" id="inline-full-name" type="text" v-model="data.title">
                    </div>
                </div>

                <div class="md:flex md:items-center mb-6">
                    <div class="md:w-1/3">
                        <label class="block text-grey-darkest font-bold md:text-left mb-1 md:mb-0 pr-4" for="inline-full-name">
                            Video Credit
                        </label>
                    </div>
                    <div class="md:w-2/3">
                        <input class="bg-grey-lighter appearance-none border-2 border-grey-lighter rounded w-full py-2 px-4 text-grey-darker leading-tight focus:outline-none focus:bg-white focus:border-grey-darkest" id="inline-full-name" type="text" v-model="data.user_credit">
                    </div>
                </div>

                <div class="md:flex md:items-center mb-6">
                    <div class="md:w-1/3">
                        <label class="block text-grey-darkest font-bold md:text-left mb-1 md:mb-0 pr-4" for="inline-full-name">
                            Video Type
                        </label>
                    </div>
                    <div class="md:w-2/3">
                        <label class="dropdown_wrap">
                            <select class="bg-grey-lighter appearance-none border-2 border-grey-lighter rounded w-full py-2 px-4 text-grey-darker leading-tight focus:outline-none focus:bg-white focus:border-grey-darkest" v-model="data.type">
                                <option value="eng">B-Roll (ENG)</option>
                                <option value="stock">Stock</option>
                            </select>
                        </label>
                    </div>
                </div>

                <div class="md:flex md:items-center mb-6">
                    <div class="md:w-1/3">
                        <label class="block text-grey-darkest font-bold md:text-left mb-1 md:mb-0 pr-4" for="inline-full-name">
                            Visibility
                        </label>
                    </div>
                    <div class="md:w-2/3">
                        <label class="dropdown_wrap">
                            <select class="bg-grey-lighter appearance-none border-2 border-grey-lighter rounded w-full py-2 px-4 text-grey-darker leading-tight focus:outline-none focus:bg-white focus:border-grey-darkest" v-model="visibility">
                                <option value="public">Public</option>
                                <option value="unlisted">Unlisted</option>
                            </select>
                        </label>
                    </div>
                </div>

                <div class="md:flex md:items-center mb-6">
                    <div class="md:w-1/3">
                        <label class="block text-grey-darkest font-bold md:text-left mb-1 md:mb-0 pr-4" for="inline-full-name">
                            Embargo
                        </label>
                    </div>
                    <div class="md:w-2/3">
                        <input class="bg-grey-lighter appearance-none border-2 border-grey-lighter rounded w-full py-2 px-4 text-grey-darker leading-tight focus:outline-none focus:bg-white focus:border-grey-darkest" id="inline-full-name" type="text" v-model="embargo">
                    </div>
                </div>

                <div class="md:flex md:items-center mb-6 mt-6">
                    <div class="md:w-1/3">
                        <label class="block text-grey-darkest font-bold md:text-left mb-1 md:mb-0 pr-4" for="inline-full-name">
                            Decline Message
                        </label>
                    </div>
                    <div class="md:w-2/3">
                        <textarea class="bg-grey-lighter appearance-none border-2 border-grey-lighter rounded w-full py-2 px-4 text-grey-darker leading-tight focus:outline-none focus:bg-white focus:border-grey-darkest" rows="4" v-model="declineMessage"></textarea>
                    </div>
                </div>

                <!-- footer -->
                <div class="mt-10 clearfix">
                    <!-- @click="addAnnouncement()" -->
                    <button v-on:click="decline" class="px-4 py-2 text-gray-800 font-semibold bg-white hover:bg-gray-100 border rounded focus:outline-none focus:shadow-outline float-left">
                        Decine Video
                    </button>
                    <button v-on:click="accept" :disabled="price == null" class="px-4 py-2 text-white font-semibold bg-blue-700 hover:bg-blue-800 border border-transparent rounded focus:outline-none focus:shadow-outline float-right">
                        Approve Video
                    </button>
                </div>

            </div>

        </div>
    </Modal>

</template>

<script>
    import { EventBus } from '@/utils/events'
    import * as Config from '@/config'
    import { mapState, mapGetters } from 'vuex'
    import plyr from 'plyr'
    import moment from 'moment';
    import YouTubePlayer from '@/components/media/components/YouTubePlayer'
    var Hls = require('hls.js')

    import Modal from '@/components/Modal'
    import StarRating from '@/components/general/StarRating'

    export default {
        data() {
            return {
                displayModal: false,
                modal: false,
                data: {},
                price: null,
                visibility: 'public',
                playlists: [],
                player: null,
                embargo: null,
                userCollection: [],
                user: null,
                declineMessage: null,
                rating: 3.5,
                user_credit: null,
            }
        },

        components: {
            Modal,
            YouTubePlayer,
            StarRating
        },

        mounted() {
            this.$nextTick(function () {
                EventBus.$on('admin-approve-video-open-modal', this.open);
            }.bind(this));

            $(this.$refs.vuemodal).on("hidden.bs.modal", this.stopPlayerOnModalClose)
        },

        destroyed() {
            EventBus.$off('admin-approve-video-open-modal', this.open);
        },

        watch: {
            rating: function(val) {
                if (/[a-zA-Z]/.test(val)) {
                    this.$swal(
                        'Whoops!',
                        'Your rating must not contain any letters.',
                        'error'
                    )
                }
                if(val < 0 || val > 5) {
                    this.$swal(
                        'Whoops!',
                        'Your rating must be between 0 and 5.',
                        'error'
                    )
                }
            }
        },

        methods: {
             ...mapGetters([
                'getAuthorizationHeader',
            ]),

            close() {
                this.stopPlayerOnModalClose();
            },

            open(data) {
                this.displayModal = true
                this.data = data;
                this.user = this.data.user;
            },

            accept() {
                var data = {
                    id: this.data.id,
                    price: this.price,
                    visibility: this.visibility,
                    type: this.data.type,
                    user: this.user,
                    embargo: this.embargo,
                    title: this.data.title,
                    rating: this.rating
                }
                var _this = this
                this.$http.post(Config.apiPath + "/api/v2/admin/videos/approval/accept", data, this.getAuthorizationHeader()).then((response) => {
                    if(response.status == 200) {
                        EventBus.$emit('admin-approve-video-refresh-data');
                        _this.toggleModal()
                    }
                });
            },

            decline() {
                this.$swal({
                    title: 'Continue?',
                    text: "Are you sure you want to decline this video?",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, decline video.'
                }).then((result) => {
                    if (result.value) {
                        var data = {
                            id: this.data.id,
                            declineMessage: this.declineMessage,
                        }
                        var _this = this;
                        this.$http.post(Config.apiPath + "/api/v2/admin/videos/approval/decline", data, this.getAuthorizationHeader()).then((response) => {
                            if(response.status == 200) {

                                EventBus.$emit('admin-approve-video-refresh-data');
                                _this.toggleModal()

                            }
                        });
                    }
                });                
            },

            stopPlayerOnModalClose() {
                this.player[0].stop();
            },

            getOptions(search, loading) {
                loading(true)
                var data = {
                    name: search,
                }
                this.$http.post(Config.apiPath + '/api/v2/admin/users/search/stringers', data, this.getAuthorizationHeader())
                    .then(response => {
                        this.userCollection = response.data;
                        loading(false)
                    })
            },

            toggleModal() {
                this.displayModal = false
            }

        }
        
    }
</script>

<style>
    .video-preview {
        text-align: center;
        color: #495057;
    }
    .min-h-content {
        min-height: -moz-min-content;
        min-height: -webkit-min-content;
        min-height: min-content;    
    }
</style>